// extracted by mini-css-extract-plugin
export default {"brandTrendingWrap":"XF-z"};